import { Pipe, PipeTransform } from '@angular/core';

import { environment } from '@rocksoft/environment';
import { Device } from '../../models/device.model';

@Pipe({ name: 'mdmLink' })
export class MdmLinkPipe implements PipeTransform {
  transform(value: Device): string | undefined {
    if (!environment.mdm.deviceUrl) {
      throw new Error('The MDM Device Url is not set in the environment configuration.');
    }

    if (!value?.udid) {
      return;
    }

    // TODO Support other device types
    return `${environment.mdm.deviceUrl}/apple/${value.udid}`;
  }
}
